/* eslint-disable jsx-a11y/anchor-has-content,react/no-danger,react/self-closing-comp */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import "./_yitm__general.scss";

const GET_COMPONENT = gql`
query paragraphRevisionById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphMobileComponentCalloutList {
          fieldListItems {
            entity {
              ... on ParagraphInnerCalloutListItem {
                fieldTxtHeadline
              }
            }
          }
        }
      }
    }
  }
}
`;

class MobileComponentDownloadCard extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired
    };

    static defaultProps = {
        componentIndex: null
    };

    render() {
        const {id, markComponentLoadedAs} = this.props;

        return (
            <Query asyncMode query={GET_COMPONENT} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const list = data.paragraphById.fieldListItems;

                    markComponentLoadedAs(id, true);

                    return (
                        <div className="yitm__list">
                            <ul>
                                {list.map(item => (
                                    <li className="container" dangerouslySetInnerHTML={{__html: item.entity.fieldTxtHeadline}}/>
                                ))}
                            </ul>
                        </div>
                    );
                }}
            </Query>
        )
    }

}


export default MobileComponentDownloadCard;



// WEBPACK FOOTER //
// ./frontend/components/YITMMobile/MobileComponentCalloutList.jsx